import { render, staticRenderFns } from "./ContactArchivedList.vue?vue&type=template&id=19f7ec9c&"
import script from "./ContactArchivedList.vue?vue&type=script&lang=js&"
export * from "./ContactArchivedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports